module.exports = __webpack_public_path__ + "static/affordable-4138130d8f6e711661b99e060428e000.png";